import { mapAPITypeToTypename } from "./serializer/mapApiTypeToTypename"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface JsonApiObject<T = Record<string, any>> {
  id: string
  attributes: T
  type: string
}

// JSON:API allows a top-level `links` member alongside `data`. Only the
// pagination subset is declared, because that is all the API sends and all any
// transformer reads; the spec's other members (`self`, `first`, `last`) would be
// dead surface. Values are plain URL strings rather than the spec's link
// objects, which the API does not use.
export interface JsonApiLinks {
  prev?: string | null
  next?: string | null
}

export interface JsonApiResponse {
  data: JsonApiObject | JsonApiObject[]
  included: JsonApiObject[] | undefined
  links?: JsonApiLinks
}

function insertTypeIntoAttributes(jsonAPIObject: JsonApiObject) {
  return {
    ...jsonAPIObject,
    attributes: {
      ...jsonAPIObject.attributes,
      type: mapAPITypeToTypename(jsonAPIObject.type)
    }
  }
}

export function transformJsonApiResponse(
  result: JsonApiResponse
): JsonApiResponse {
  return {
    ...result,
    data: Array.isArray(result.data)
      ? result.data.map(d => insertTypeIntoAttributes(d))
      : insertTypeIntoAttributes(result.data),
    included: result.included?.map(d => insertTypeIntoAttributes(d))
  }
}
